// extracted by mini-css-extract-plugin
module.exports = {"root":"StickyBox_root__yC6cI","left":"StickyBox_left__1BJCE","right":"StickyBox_right__1SJ9m"};